import { render, staticRenderFns } from "./OrganizationListMdt.vue?vue&type=template&id=4a7f3356&scoped=true"
import script from "./OrganizationListMdt.vue?vue&type=script&lang=js"
export * from "./OrganizationListMdt.vue?vue&type=script&lang=js"
import style0 from "./OrganizationListMdt.vue?vue&type=style&index=0&id=4a7f3356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f3356",
  null
  
)

export default component.exports